import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

export interface FilterBarItem {
  id: string
  link: string
  text: string
  isActive?: boolean
}

interface FilterBarProps {
  items: FilterBarItem[]
  filterLink: string
  showBadge?: boolean
  className?: string
}

export const FilterBar = ({
  items,
  filterLink,
  showBadge,
  className,
}: FilterBarProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(s.filterBar, className)}>
      <div className={s.list}>
        {items.map((item) => (
          <div
            key={item.id}
            className={s.item}
          >
            <Link
              className={clsx(
                s.itemLink,
                'medium-12',
                item.isActive && s.active,
              )}
              to={item.link}
            >
              {item.text}
              <AppIcon
                id={AllIcons.ARROW_LEFT}
                className={s.icon}
                width={14}
                height={14}
              />
            </Link>
          </div>
        ))}

        <Link
          className={s.filterButton}
          to={filterLink}
          aria-label={t('filters')}
        >
          <AppIcon
            id={AllIcons.FILTER}
            className={s.icon}
            width={26}
            height={26}
          />
          {showBadge && <span className={s.badge} />}
        </Link>
      </div>
    </div>
  )
}
